import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, destructive } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	contentExtras: {
		height: '100%',
	},
	centeredContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 400,
		gap: 16,
	},
	loadingText: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
	},
	errorTitle: {
		fontSize: 20,
		fontWeight: 600,
		color: destructive,
		margin: 0,
	},
	errorMessage: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
		maxWidth: 500,
	},
});
